module.exports = __webpack_public_path__ + "static/logo-81ad10c05e70db64eee336d353400d63.png";